require('pager');// strange, but as plugin pagerjs refuse to work, so it must be "require" here

require('./index.less');// this inclusion is necessary for creation separate build of styles for entry point "bulk-po"

var router = require('./scripts/services/router');
var publicData = require('./scripts/services/publicData');

var viewModel = require('./scripts/viewModel');
var preloader = require('./scripts/components/preloader');

pager.onNoMatch.add(function (params) {
    if (params.page.route.length == 0 || router.isExistingRoute(params.page.route[0])) return;

    router.goTo('default');
});
pager.extendWithPage(viewModel);
ko.applyBindings(viewModel);
pager.start(router.getDefaultRoute());

preloader.init();
publicData.init(viewModel, function () {
    viewModel.init();
});











//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/index.js
// module id = 17
// module chunks = 0